import Specialties from './Specialties';

export default Specialties;
